import { kaspreadsheetUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px] md:min-h-[600px]">
      <div className="lg:w-1/2 relative overflow-hidden min-h-[320px]">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20artistic%20texture%20with%20layered%20organic%20waves%20in%20warm%20terracotta%20sand%20and%20cream%20tones%2C%20subtle%20linen%20fabric%20pattern%20suggestion%2C%20minimalist%20airy%20composition%2C%20no%20text%2C%20modern%20Mediterranean%20aesthetic%2C%20soft%20diffused%20lighting%2C%20clean%20warm%20neutral%20palette&width=900&height=700&seq=cta-bg-left-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-primary-500/20 mix-blend-multiply"></div>
        <span className="absolute top-6 left-6 text-xs font-semibold text-foreground-700/60 uppercase tracking-wider bg-white/60 backdrop-blur-sm px-3 py-1 rounded-full whitespace-nowrap">
          Start Sourcing
        </span>
        <h3 className="absolute bottom-8 left-6 text-3xl md:text-4xl lg:text-5xl font-extrabold font-heading text-foreground-950 leading-none">
          Ready to
          <br />
          Level Up?
        </h3>
      </div>

      <div className="lg:w-1/2 flex items-center justify-center px-6 py-14 md:py-20 bg-white">
        <div className="max-w-md text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold font-heading text-foreground-950 leading-tight">
            Find Your Next
            <br />
            Profitable Flip
          </h2>
          <p className="mt-5 text-base text-foreground-500 leading-relaxed max-w-sm mx-auto">
            Browse thousands of products across 14 categories on KA Spreadsheet. From sneakers to accessories, discover inventory that moves — all backed by GTBuy spreadsheet tools.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={kaspreadsheetUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold text-white bg-foreground-900 hover:bg-foreground-800 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              gtb<span className="text-primary-400">u</span>y sheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
            <a
              href={kaspreadsheetUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold text-foreground-700 bg-background-100 hover:bg-background-200 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              buy it now
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-shopping-bag-line text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}